import {
  ALERT,
  BASKET_SERVICE_TYPE,
  DAYS_OF_WEEK,
  EXCEED_AMOUNTS,
  FNS_DATE_FORMAT,
  PRINTER_MESSAGE,
  GENERIC_ERROR,
  DATE_FORMAT,
  DATE_FORMAT_MONTH,
  RETAIL_VALUE_TYPE,
} from 'globalConstants';
import {
  CUSTOMER_KYC_STATUS,
  CUSTOMER_PROFILE_LABEL,
  DOB_ALLOWEd_AGE,
  DOB_ERROR_MESSAGE,
  INVALID_DATE_MESSAGE,
  PROFILE_STATUS,
  PURCHASE_STATUS,
} from 'components/customer/constants';
import { differenceInBusinessDays, format, getDay, isBefore } from 'date-fns';
import {
  isArrayBuffer,
  cloneDeep,
  isEmpty,
  isNaN,
  isNull,
  isUndefined,
} from 'lodash';

import atob from 'atob';
import moment from 'moment';
import { notification } from 'antd';

import {
  LOAN_STATUS,
  AUCTION_STATUS,
  PURCHASE_CHARGE_OFF_REASON,
} from 'components/pickupRenew/constants';
import { sendToPrinter } from 'services/user';
import { VALUATION_LABELS } from 'components/valuationCenter/constants';
import { Iany } from 'components/common/types/Shared';
import { FILE_TYPE } from 'components/reports/constant';
import dayjs from 'dayjs';
import { postAuctionLoanStatus } from 'services/pledgeManagement';

export const removeHTMLTags = (strValue: string): string => {
  if (strValue === null || strValue === '' || strValue === undefined) return '';
  return strValue.replace(/(<([^>]+)>)/gi, '');
};

export const joinValues = (
  values: string[],
  includeWhitespace = false,
): string => {
  const nonNullValues = values.filter((n) => n);
  return includeWhitespace ? nonNullValues.join(' ') : nonNullValues.join(', ');
};

export const b64toBlob = (dataURI: any) => {
  if (!dataURI) return;
  const byteString = atob(dataURI.split(',')[1]);
  const ab = new ArrayBuffer(byteString.length);
  const ia = new Uint8Array(ab);

  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }
  return new Blob([ab], { type: 'image/jpeg' });
};

export const getTimestamp = (dateString: string) => {
  return Date.parse(dateString);
};

export const reducePledgeItems = (data: any) => {
  const items = data?.reduce((acc: any, item: any) => {
    const obj: object | any = {};
    Object.keys(item).map((key) => {
      return (obj[key] = item[key]?.id === 0 ? 0 : item[key]?.id || item[key]);
    });
    if (!isEmpty(obj)) return [...acc, obj];
    else return [...acc];
  }, []);
  return items;
};

//to test all keys inside object are undefined
export const isEmptyObject = (obj: any) => {
  const result = Object.values(obj).every((o) => o === undefined);
  return result;
};

export const currencyFormat = (x: number | string, isGBP = false) => {
  if (!isUndefined(x) && !isNull(x)) {
    const numSign = Math.sign(+x);
    let formattedVal = toFixedNoRound(Math.abs(+x))
      ?.toString()
      ?.replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',');

    if (isGBP) {
      formattedVal = ' £' + formattedVal;
    }
    if (numSign === -1) {
      formattedVal = '-' + formattedVal;
    }
    return formattedVal;
  }
};

export const toFixedNoRound = (x: number | string, fixedToDecimal = 2) => {
  if (!isUndefined(x) && !isNull(x)) {
    const pattern = new RegExp(
      '^-?\\d+(?:.\\d{0,' + (fixedToDecimal || -1) + '})?',
    );
    return Number(x?.toString()?.match(pattern))?.toFixed(fixedToDecimal);
  }
};

export const filterBasketItemsOnServiceType = (
  basket: any,
  serviceType: number,
) => {
  const filteredItems = !isEmpty(basket)
    ? basket?.basketServices.filter(
        (item: any) => item.serviceType === serviceType,
      )
    : [];
  return filteredItems;
};

export const filterBasketItemsOnServiceId = (
  basket: any,
  serviceId: number,
) => {
  const filteredItems = !isEmpty(basket)
    ? basket?.basketServices.filter((item: any) => item.serviceId === serviceId)
    : [];
  return filteredItems;
};

export const calculateTotalSum = (items: any) => {
  return items.reduce((a: number, b: number) => a + b, 0);
};

/** filter loan amount as per different-2 basket item like pledge, retail */
export const allLoanAmounts = (basketItems: Array<any>, keyType: string) => {
  keyType = keyType.toLowerCase();
  const total = basketItems.reduce(
    (acc: any, item: any) => {
      const totalItemsCount =
        item[keyType]?.request?.items?.length || basketItems.length;
      const totalLoanAmount = item.serviceAmount;

      return {
        totalItemsCount: totalItemsCount || 0,
        totalAmounts: acc.totalAmounts + totalLoanAmount,
        totalAmountPerTabs: [
          ...acc.totalAmountPerTabs,
          Math.abs(totalLoanAmount),
        ],
        innerTabsCount: basketItems.length,
      };
    },
    {
      totalItemsCount: 0,
      totalAmounts: 0,
      innerTabsCount: 0,
      totalAmountPerTabs: [],
    },
  );
  total.totalAmounts = Math.abs(total.totalAmounts);
  return total;
};

export const calculateTotalSumByKey = (arr: Array<any>, key: string) => {
  return arr?.reduce((a: number, b: any) => a + (+b[key] || 0), 0);
};

export const formatDayAndDate = (date: any) => {
  if (date) {
    const dueDate = format(new Date(date), FNS_DATE_FORMAT);
    const dueDay = DAYS_OF_WEEK[getDay(new Date(date))];

    return `${dueDay}, ${dueDate}`;
  }
};

export const dateDisplayFormat = (
  dateStr: any,
  dateFormat: string = FNS_DATE_FORMAT,
) => {
  try {
    if (dateStr) {
      const formatedDate = format(new Date(dateStr), dateFormat);
      return formatedDate;
    }
    return '';
  } catch (e: any) {
    return dateStr;
  }
};

export const findValueByKey = (obj: object, keyType: any) => {
  let result = '';
  for (const [key, value] of Object.entries(obj)) {
    if (key === keyType) {
      result = value;
    }
  }
  return result;
};

export const reduceWatchHandbagItems = (data: any, watchAttributes: any) => {
  const obj = Object.keys(data).map((key) => {
    const watchHandbagDetails = watchAttributes.find((value: any) => {
      return value.attributeId.toString() === key;
    });
    if (watchHandbagDetails) {
      return {
        attributeId: key,
        value: data[key],
        attributeName: watchHandbagDetails?.name,
      };
    }
  });
  return obj.filter((item) => item !== undefined);
};

export const getWatchHandbagFormItem = (data: any) => {
  const result = data.reduce(
    (obj: any, item: { attributeId: any; value: any }) =>
      Object.assign(obj, { [item.attributeId]: item.value }),
    {},
  );
  return result;
};

export const isSoldDateExceed = (
  transactionDate: any,
  numberOfDays: number,
) => {
  return (
    differenceInBusinessDays(Date.now(), getTimestamp(transactionDate)) >
    numberOfDays
  );
};

//convert different services item to an item array to render in the pickup/renew page
export const getPledgeAgreementItemsArray = (items: any) => {
  return items
    .filter((x: any) => x.serviceType === BASKET_SERVICE_TYPE.PICKUPRENEW)
    .map((item: any) => {
      return item.pickupRenew.request.item;
    });
};

export const getCurrencySymbol = (
  currencies: Array<any>,
  currencyCode: string,
) => {
  return currencies?.find((item) => item.currencyCode === currencyCode)
    ?.currencySymbol;
};

export const getCustomerKycStatusIcon = (profileStatus: any) => {
  switch (profileStatus) {
    case 'green':
      return require('../assets/images/tick_green.svg').default;
    case 'red':
      return require('../assets/images/block_ic.svg').default;
    case 'yellow':
    case 'musturd':
      return require('../assets/images/tick_yellow.svg').default;
    case 'purple':
      return require('../assets/images/monitored_account_purple.svg').default;
    case 'amber':
      return require('../assets/images/monitored_account_amber.svg').default;
    case 'black':
      return require('../assets/images/monitored_account_black.svg').default;
    default:
      return '';
  }
};

export const getProfileLabel = (profileStatus: any) => {
  switch (profileStatus) {
    case CUSTOMER_KYC_STATUS[1]:
      return CUSTOMER_PROFILE_LABEL.GREEN;
    case CUSTOMER_KYC_STATUS[2]:
      return CUSTOMER_PROFILE_LABEL.RED;
    case CUSTOMER_KYC_STATUS[3]:
      return CUSTOMER_PROFILE_LABEL.YELLOW;
    case CUSTOMER_KYC_STATUS[0]:
      return CUSTOMER_PROFILE_LABEL.PURPLE;
    case CUSTOMER_KYC_STATUS[4]:
      return CUSTOMER_PROFILE_LABEL.AMBER;
    case CUSTOMER_KYC_STATUS[5]:
      return CUSTOMER_PROFILE_LABEL.BLACK;
    case CUSTOMER_KYC_STATUS[6]:
      return CUSTOMER_PROFILE_LABEL.MUSTURD;
    default:
      return CUSTOMER_PROFILE_LABEL.ERROR;
  }
};

export const createWindowURL = (id: any, data: any, page: string) => {
  const url = window.URL.createObjectURL(
    new Blob([data], { type: 'application/pdf' }),
  );
  const pdfFrame = document.body.appendChild(document.createElement('iframe'));
  pdfFrame.style.display = 'none';
  pdfFrame.onload = () => void pdfFrame?.contentWindow?.print();
  pdfFrame.src = url;
};

export const getPurchaseReturnItems = (items: any) => {
  return items
    .filter((x: any) => x.serviceType === BASKET_SERVICE_TYPE.PURCHASERETURN)
    .map((item: any) => {
      return item.purchaseReturn.request.item;
    });
};

//Check if amount is exceed then return true as per service when guest screen
export const isAmountExceed = (basket: any, valueType: any) => {
  let isValueExceed = false;
  const retailService = basket?.basketServices?.filter(
    (x: any) => x.serviceType === BASKET_SERVICE_TYPE.RETAIL,
  );

  if (valueType === RETAIL_VALUE_TYPE.LIST_VALUE) {
    // If service type retail and list value is exceeded
    isValueExceed =
      Math.abs(retailService[0].serviceAmount) >=
      EXCEED_AMOUNTS.RETAIL_LIST_VALUE;
  } else if (valueType === RETAIL_VALUE_TYPE.COST_VALUE) {
    // If service type retail and cost value is exceeded
    const allItems = retailService?.reduce((acc: any, item: any) => {
      return [...acc, ...item.retail.request.items];
    }, []);

    isValueExceed = allItems?.some(
      (item: any) => item.costValue > EXCEED_AMOUNTS.RETAIL && !item.isNew,
    );
  }

  //MP:5833 - Commenting FX check in case of futrue use
  // const fxService = basket?.basketServices?.filter(
  //   (x: any) => x.serviceType === BASKET_SERVICE_TYPE.FX
  // );
  // if (fxService && !isValueExceed) {
  //   //If service type FX and total amount is exceeded (buy currency +ve amount) and If in case of sell currency if (Pay to Customer -ve amount) value exceed
  //   isValueExceed =
  //     basket?.totalFX?.totalFXAmount > EXCEED_AMOUNTS.FX ||
  //     basket?.totalFX?.totalFXAmount < -EXCEED_AMOUNTS.FX;
  // }

  return isValueExceed;
};

export const getPurchaseStatus = (
  quarantineStatus: number,
  isReturned: boolean,
  purchaseStatus?: Iany,
) => {
  const isChargedOff = isPurchaseChargeOff(purchaseStatus);
  switch (quarantineStatus) {
    case 0:
      if (isChargedOff) {
        return PURCHASE_STATUS.WRITTEN_OFF;
      } else if (!isReturned) {
        return PURCHASE_STATUS.PFI;
      } else {
        return PURCHASE_STATUS.RETURNED;
      }
    case 1:
      if (isChargedOff) {
        return PURCHASE_STATUS.WRITTEN_OFF;
      } else if (isReturned) {
        return PURCHASE_STATUS.RETURNED;
      } else {
        return PURCHASE_STATUS.HOLD;
      }
    default:
      return PURCHASE_STATUS.HOLD;
  }
};

export const isPurchaseChargeOff = (purchaseStatus: Iany) => {
  return PURCHASE_CHARGE_OFF_REASON?.some(
    (item: Iany) => item?.value === purchaseStatus,
  );
};

export const checkAvailableCurrencies = (
  availableCurr: any,
  orderedCurr: any,
) => {
  const result = availableCurr?.reduce(
    (acc: any, item: any) => {
      const odrCurr = orderedCurr?.find(
        (o: any) => o.currency === item.currency,
      );
      const isFxAvailable = item.amount >= odrCurr?.amount;
      if (!isFxAvailable) {
        return {
          ...acc,
          currencies: [...acc.currencies, item],
          isCurrenciesNotAvailable: true,
        };
      }
      return acc;
    },
    { isCurrenciesNotAvailable: false, currencies: [] },
  );
  return result;
};

export const disabledFutureDate = (currentDate: any) => {
  return currentDate && currentDate > moment().endOf('day');
};

export const capitalize = (str: string) => {
  if (str.length > 1) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }
  return str;
};

export const validateDateOfBirth = (
  _: any,
  value: any,
  allowedMinAge = DOB_ALLOWEd_AGE.MIN_AGE,
  allowedMaxAge = DOB_ALLOWEd_AGE.MAX_AGE,
) => {
  const validAge = moment().diff(value, 'years', false);

  if (isNaN(validAge)) {
    return Promise.reject(new Error(INVALID_DATE_MESSAGE));
  }
  if (validAge < allowedMinAge) {
    return Promise.reject(
      new Error(
        DOB_ERROR_MESSAGE.MIN_AGE_PRE_TEXT +
          allowedMinAge +
          DOB_ERROR_MESSAGE.MIN_AGE_POST_TEXT,
      ),
    );
  }
  if (validAge > allowedMaxAge) {
    return Promise.reject(new Error(DOB_ERROR_MESSAGE.GREATER_THAN_150));
  }
  return Promise.resolve();
};

export const customerValidateDateOfBirth = (
  _: any,
  value: any,
  dateFormat = DATE_FORMAT,
  ageThreshold: any,
  allowedMinAge = DOB_ALLOWEd_AGE.MIN_AGE,
  allowedMaxAge = DOB_ALLOWEd_AGE.MAX_AGE,
) => {
  let formattedValue = value;
  if (dateFormat === DATE_FORMAT) {
    const parsedDate = moment(formattedValue, DATE_FORMAT);
    formattedValue = parsedDate.format(DATE_FORMAT_MONTH);
  }

  const validAge = moment().diff(formattedValue, 'years', false);

  if (isNaN(validAge)) return INVALID_DATE_MESSAGE;
  else if (ageThreshold && validAge < ageThreshold)
    return `${DOB_ERROR_MESSAGE.MIN_AGE_PRE_TEXT} ${allowedMinAge} ${DOB_ERROR_MESSAGE.MIN_AGE_POST_TEXT}`;
  else if (validAge > allowedMaxAge) return DOB_ERROR_MESSAGE.GREATER_THAN_150;

  return '';
};

export const getPledgePurchaseChildTab = (
  basket: any,
  activeService: any,
  targetServiceId: any,
) => {
  const services = basket?.basketServices?.filter(
    (x: any) => x.serviceType === +activeService,
  );

  if (targetServiceId) {
    const serviceIndex = services?.findIndex(
      (service: any) => service.serviceId === targetServiceId,
    );

    return serviceIndex + 1;
  } else return services.length;
};

export const calculateTotalWeight = (arr?: Array<any>) => {
  const totalWeight =
    arr && arr.length > 0
      ? arr.reduce((a: number, b: any) => {
          //commenting the code - MP-6282, MP-6289, EVB-774
          // if (b['loanItemType']['id'] === +BASE_PLEDGE_CATEGORIES[2].id) {
          //   return (
          //     // a + b['itemValuation']['coinPrice']['weight'] + b['totalWeight']
          //     a + b['itemValuation']['coinPrice']['weight']
          //   );
          // } else
          return a + b['totalWeight'];
        }, 0)
      : 0;

  return totalWeight;
};

export const getParentImageUrl = (imageCollection: any) => {
  const parentImage = imageCollection?.images?.find(
    (obj: any) => obj.isDefault === true,
  );

  if (parentImage) {
    if (parentImage?.itemImageId) {
      return `/api/items/image/${parentImage.containerId}/${parentImage.blobId}?itemImageId=${parentImage?.itemImageId}`;
    } else
      return `/api/items/image/${parentImage.containerId}/${parentImage.blobId}`;
  }

  return '';
};

export const getLowercaseWithoutSpace = (value: string) => {
  if (value) return value?.toLowerCase().replace(/\s/g, '');
  return '';
};

export const getObjectKeyForValue = (obj: any, valueString: any) => {
  for (let [key, value] of Object.entries(obj))
    if (value === valueString) return key;
  return 0;
};

export const getPledgeIcons = (
  row: any,
  vulnerabilityStatus: string = '',
  showChangeOwnershipIcon = false,
  isFeatureFlag: boolean = false,
) => {
  // 1 - Confiscated
  // 2 - Vulnerable
  let statusIcons = [];

  const getIcons = (row: any, vulnerabilityStatus: string) => {
    switch (row?.confiscated) {
      case 0:
      case 2:
        return getStatusIconValue(row, vulnerabilityStatus);
      case 1:
        if (!isFeatureFlag) return [LOAN_STATUS.CONFISCATED, null];
        else return [LOAN_STATUS.POLICE_HOLD, null];
      default:
        return [row.loanStatus, null];
    }
  };

  statusIcons = getIcons(row, vulnerabilityStatus);

  if (
    showChangeOwnershipIcon &&
    (row?.isOwnerShipChanged || row?.changeOwnership?.isOwnershipChanged)
  ) {
    statusIcons.push(LOAN_STATUS.CHANGE_OWNERSHIP);
  }
  return statusIcons;
};

const getStatusIconValue = (row: any, vulnerabilityStatus: string) => {
  if (row?.auctionStatus === AUCTION_STATUS.LIVE_AT_STORE) {
    if (row?.loanStatus === LOAN_STATUS.OPEN) {
      if (row?.auctionLoanStatus === AUCTION_STATUS.PASS_NO_PAY)
        return [row?.loanStatus, LOAN_STATUS.PASS_NO_PAY];
      else return [row?.loanStatus, LOAN_STATUS.PFA_AT_STORE];
    } else {
      return [row?.loanStatus];
    }
  } else if (row?.auctionStatus === AUCTION_STATUS.LIVE_AT_AUCTION) {
    const bagSentOn = row?.bagSentOn ? new Date(row?.bagSentOn) : 0;
    const loanClosedOn = row?.closedDate ? new Date(row?.closedDate) : 0;
    const deletedOn = row?.deletedOn ? new Date(row?.deletedOn) : 0;

    if (row?.loanStatus !== LOAN_STATUS.OPEN) {
      if (
        (loanClosedOn && bagSentOn && isBefore(loanClosedOn, bagSentOn)) ||
        (deletedOn && bagSentOn && isBefore(deletedOn, bagSentOn))
      ) {
        return [row?.loanStatus]; //loan was picked up before bag moved to Live at auction so only loan status to show.
      } else return [row?.loanStatus, LOAN_STATUS.PFA_AT_AUCTION_HOUSE]; // loan was picked up after bag moved to Live at Auction
    } else if (row?.loanStatus === LOAN_STATUS.OPEN) {
      if (
        row?.auctionLoanStatus === AUCTION_STATUS.PASS_NO_PAY &&
        deletedOn &&
        bagSentOn &&
        isBefore(deletedOn, bagSentOn)
      ) {
        return [
          row?.loanStatus,
          row?.auctionLoanStatus === AUCTION_STATUS.PASS_NO_PAY &&
            LOAN_STATUS.PASS_NO_PAY,
        ];
      } else {
        return [
          row?.loanStatus,
          LOAN_STATUS.PFA_AT_AUCTION_HOUSE,
          row?.auctionLoanStatus === AUCTION_STATUS.PASS_NO_PAY &&
            LOAN_STATUS.PASS_NO_PAY,
        ];
      }
    } else {
      return [
        row?.loanStatus,
        LOAN_STATUS.PFA_AT_AUCTION_HOUSE,
        row?.auctionLoanStatus === AUCTION_STATUS.PASS_NO_PAY &&
          LOAN_STATUS.PASS_NO_PAY,
      ];
    }
  } else if (row?.auctionLoanStatus === AUCTION_STATUS.SOLD_AT_AUCTION) {
    return [LOAN_STATUS.SOLD_AT_AUCTION];
  } else if (row?.auctionStatus === AUCTION_STATUS.UNDER_THE_HAMMER) {
    return [LOAN_STATUS.UNDER_THE_HAMMER];
  }

  if (
    row?.loanStatus === LOAN_STATUS.PICKED_UP &&
    (row?.isWithdraw || row?.isExistingWithdrawNotice)
  )
    return [LOAN_STATUS.WITHDRAWN, null];
  if (row?.loanStatus === LOAN_STATUS.PICKED_UP && row?.isOnlinePickup)
    return [LOAN_STATUS.ONLINE_PICKED_UP, LOAN_STATUS.ONLINE_PICKED_UP_TEXT];

  if (row?.loanStatus === LOAN_STATUS.OPEN) {
    if (vulnerabilityStatus === PROFILE_STATUS.BLACK || row?.isLocked) {
      let icons = [];

      if (row?.pledgeServicePermissions) {
        let { renewal, paydown, partialPayment, pfiAuction } =
          row?.pledgeServicePermissions;

        if (renewal && paydown && partialPayment && pfiAuction)
          return [LOAN_STATUS.OPEN];
        else if (!renewal && !paydown && !partialPayment && !pfiAuction)
          return [LOAN_STATUS.LOCKED];
        else {
          if (renewal) icons.push(LOAN_STATUS.RENEWAL);
          if (paydown) icons.push(LOAN_STATUS.PAYDOWN);
          if (partialPayment) icons.push(LOAN_STATUS.PARTIAL_PAY);
          if (pfiAuction) icons.push(LOAN_STATUS.PFI_AUCTION);
          return [LOAN_STATUS.LOCKED, ...icons];
        }
      }

      return [LOAN_STATUS.LOCKED];
    }

    if (row?.pledgeServicePermissions) {
      let icons = [];

      let { renewal, paydown, partialPayment } = row?.pledgeServicePermissions;

      if (renewal && paydown && partialPayment) {
        if (
          typeof row?.affidavitFees?.reasonId !== 'undefined' &&
          row?.affidavitFees?.reasonId !== null
        ) {
          icons.push(LOAN_STATUS.AFFIDAVIT_ICON);
          return [LOAN_STATUS.OPEN, ...icons];
        }
        return [LOAN_STATUS.OPEN];
      } else if (!renewal && !paydown && !partialPayment)
        return [LOAN_STATUS.IS_AT_RISK];
      else {
        if (renewal) icons.push(LOAN_STATUS.RENEWAL);
        if (paydown) icons.push(LOAN_STATUS.PAYDOWN);
        if (partialPayment) icons.push(LOAN_STATUS.PARTIAL_PAY);
        return [LOAN_STATUS.IS_AT_RISK, ...icons];
      }
    }

    //fallback status for CST - In case pledgeServicePermissions comes up empty
    if (vulnerabilityStatus === PROFILE_STATUS.AMBER || row?.isAtRisk)
      return [LOAN_STATUS.IS_AT_RISK];

    if (row?.isRequestedForWithdraw || row?.isExistingWithdrawNotice)
      return [LOAN_STATUS.OPEN, LOAN_STATUS.WITHDRAW_LATER];

    if (row?.isEarlySettlement || row?.isEarlySettlementRaised)
      return [LOAN_STATUS.OPEN, LOAN_STATUS.EARLY_SETTLEMENT];
  }

  if (row?.loanStatus === LOAN_STATUS.OPEN && row?.loanstatuses?.length) {
    return [LOAN_STATUS.OPEN, ...row?.loanstatuses];
  }

  if (
    (row?.affidavitAmount === 0 &&
      typeof row?.affidavitFees?.reasonId !== 'undefined' &&
      row?.affidavitFees?.reasonId !== null) ||
    row?.waiveInterest?.isWaivedOffAffidavitAmount
  )
    return [row.loanStatus, LOAN_STATUS.AFFIDAVIT_ICON];

  return [row.loanStatus, null];
};

export const arrayBufferTob64 = (data: any) =>
  btoa(
    new Uint8Array(data).reduce(
      (data, byte) => data + String.fromCharCode(byte),
      '',
    ),
  );

export const createArrayChunks = (arr: any, size: number) => {
  if (!arr || arr?.lenght === 0) return [];
  if (arr?.lenght === 1) return arr;

  return Array?.from({ length: Math.ceil(arr?.length / size) }, (v, i) =>
    arr.slice(i * size, i * size + size),
  );
};

export const sortArrayByKey = (
  arr: Array<any>,
  objKey: string,
  order: boolean = false,
) => {
  var sortedArray = [...arr];
  sortedArray?.sort((a: any, b: any) =>
    a[objKey] < b[objKey] ? 1 : a[objKey] > b[objKey] ? -1 : 0,
  );

  // order: true -> ascending order
  if (order) {
    const orderedArr = cloneDeep(sortedArray).reverse();
    return orderedArr;
  }

  return sortedArray;
};

// rate-modification utils
export const calculateInterestRateFromRateBands = (
  totalAmount: number,
  rateBands: Array<any>,
) => {
  if (totalAmount) {
    let rateDetailsForAmount = rateBands.find(
      (obj) => obj.loanAmountUpperLimit >= totalAmount,
    );

    return rateDetailsForAmount;
  }

  return {};
};

export const getNotification = (
  type: any,
  message: any,
  description = '',
  duration = ALERT.DURATION.GENERIC,
) => {
  let params = {
    message: message,
    description: description,
    duration: duration,
  };
  type === ALERT.STATUS.SUCCESS
    ? notification.success(params)
    : type === ALERT.STATUS.ERROR
      ? notification.error(params)
      : notification.warning(params);
};

export const getGenericError = (errorMsg = GENERIC_ERROR) => {
  getNotification(ALERT.STATUS.ERROR, errorMsg);
};

export const caseInsensitivePropSearch = (obj: any, prop: any) => {
  const searchProp = (prop + '').toLowerCase();
  for (const p in obj) {
    // eslint-disable-next-line no-prototype-builtins
    if (obj.hasOwnProperty(p) && searchProp == (p + '').toLowerCase()) {
      return obj[p];
    }
  }
};

export const arrayBufferToJSON = (data: any) => {
  if (!isArrayBuffer(data)) return {};
  return JSON.parse(new TextDecoder().decode(data));
};

export const callPrinter = (
  pdfData: any,
  type: any,
  filename: any,
  showNotification = false,
  notificationMessage = PRINTER_MESSAGE.PRINT_SUCCESS,
  options = {},
) => {
  if (pdfData?.data) {
    const printStatus = sendToPrinter(pdfData, type, filename, options);
    if (showNotification) {
      getNotification(ALERT.STATUS.SUCCESS, notificationMessage, '');
    }
    return printStatus;
  }
};
export const getErrorSuccessNotification = (
  actions: any,
  dispatch: any,
  isErrorVisible: any,
  error = '',
  isSuccessMsgVisible: any,
  successMsg = '',
) => {
  if (isErrorVisible) {
    getNotification(ALERT.STATUS.ERROR, error);
    dispatch(actions?.setIsErrorVisible(false));
  }

  if (isSuccessMsgVisible) {
    getNotification(ALERT.STATUS.SUCCESS, successMsg);
    dispatch(actions?.setIsSuccessMsgVisible(false));
  }
};

export const trimWhitespaceRule = {
  validator: (_: any, value: any) => {
    if (value && value.trim() === '') {
      return Promise.reject(new Error('Field cannot be just whitespace'));
    }
    return Promise.resolve();
  },
};

export const checkValuationStatusId = (
  valuationStatusId: any,
  ...statusIds: any
) => {
  return statusIds.includes(valuationStatusId);
};

export const checkValuationActionCicked = (actionClicked: any) => {
  return [VALUATION_LABELS.EDIT, VALUATION_LABELS.RESUBMIT].includes(
    actionClicked,
  );
};

export const isValidBarcode = (value: string, isBarcodeSearch?: boolean) => {
  if (!value) {
    return false;
  }
  if (!isBarcodeSearch) {
    const transferBarcode = value.match(/\d+/g); // atleast 3 digit number in a transfer ref.
    if (!transferBarcode || transferBarcode[0].toString().length < 3) {
      return false;
    } else {
      return true;
    }
  }
  if (
    isBarcodeSearch &&
    value?.length < 6 // 6 digit barcode string
  ) {
    return false;
  }
  return true;
};

export const checkPledgePurchaseValuationBasket = (basket: Iany) => {
  const isPledgeValuationBasket = filterBasketItemsOnServiceType(
    basket,
    BASKET_SERVICE_TYPE.PLEDGE,
  )[0]?.pledge?.request?.items?.some((y: any) => {
    return y.valuationReference;
  });

  const isPurchaseValuationBasket = filterBasketItemsOnServiceType(
    basket,
    BASKET_SERVICE_TYPE.PURCHASE,
  )[0]?.purchase?.request?.items?.some((y: any) => {
    return y.valuationReference;
  });

  return isPledgeValuationBasket || isPurchaseValuationBasket;
};

export const validEmail = (value: String) => {
  const emailRegex = new RegExp(
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+\.)+[a-zA-Z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]{2,}))$/,
  );

  return value.length <= 60 && !!value.match(emailRegex);
};

export const formatStringToStartCase = (value: Iany) => {
  const stringWithSpecialCharRegex = new RegExp(/^[a-zA-Z-/]+$/); // RegEx that matches only string a-z or A-Z with special characters "/" and "-"
  const romanNumbersRegex = new RegExp(
    /^M{0,3}(CM|CD|D?C{0,3})(XC|XL|L?X{0,3})(IX|IV|V?I{0,3})$/,
  ); // RegEx that matches roman numbers

  if (isNull(value) || isUndefined(value) || value === '') return '-';
  else if (typeof value === 'string')
    return joinValues(
      value
        .trim()
        .split(' ')
        .map((splitValue: string) => {
          return stringWithSpecialCharRegex.test(splitValue) &&
            !romanNumbersRegex.test(splitValue)
            ? splitValue.slice(0, 1).toUpperCase() +
                splitValue.slice(1).toLowerCase()
            : splitValue;
        }),
      true,
    );
  else return value;
};

export const getPastThreeMonthDate = () => {
  const date = new Date();
  date.setMonth(date.getMonth() - 3);

  return date;
};

export const handleCopy = (event: any) => {
  event.preventDefault();
  getNotification(ALERT.STATUS.ERROR, 'Copying customer data is restricted !');
};

export const copyHandler = (event: any) => {
  const { ctrlKey, key } = event;

  if (ctrlKey && key === 'c') handleCopy(event);
};

export const getSortedData = (data: Iany, sortingParams: Iany) => {
  const { selector, desc } = sortingParams;
  return data?.sort((a: any, b: any) => {
    const valA = a[selector];
    const valB = b[selector];
    //sort logic if data is number
    if (typeof valA === 'number' && typeof valB === 'number') {
      return desc ? valB - valA : valA - valB;
    }
    //sort logic if data is string
    if (typeof valA === 'string' && typeof valB === 'string') {
      return desc ? valB.localeCompare(valA) : valA.localeCompare(valB);
    }
  });
};

export const downloadPDFOrExcel = (
  response: Iany,
  fileName: Iany,
  fileType = FILE_TYPE.PDF,
) => {
  const blob = new Blob([response?.data], {
    type:
      fileType === FILE_TYPE.EXCEL
        ? 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        : fileType === FILE_TYPE.CSV
          ? 'text/csv;charset=utf-8;'
          : 'application/pdf',
  });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  a.remove();
};

export const getBinaryImageRemoved = (itemImageCollectionResponse: any) => {
  const imagesInPayload = itemImageCollectionResponse?.images?.map(
    (item: any, index: number) => {
      return {
        itemImageId: item?.itemImageId || 0,
        sequenceId: item?.sequenceId || index,
        isDefault: item?.isDefault,
        containerId: item?.containerId,
        blobId: item?.blobId,
        thumbnailBlobId: item?.thumbnailBlobId || item?.thumbnailImageId || '',
        label: item?.label || null,
      };
    },
  );
  return imagesInPayload;
};

export const disabledDate = (current: Iany) => {
  const today = dayjs();
  const ninetyDaysAgo = today.subtract(90, 'day');
  return current < ninetyDaysAgo.startOf('day') || current > today.endOf('day');
};

export const checkDisableToDate = (current: Iany, fromDate: Iany) => {
  if (!fromDate) return disabledDate(current);
  const maxToDate = fromDate.add(1, 'day');
  return (
    current < fromDate.startOf('day') ||
    current > maxToDate.endOf('day') ||
    disabledDate(current)
  );
};

export const handleFromChange = (date: Iany, form: Iany) => {
  const today = dayjs();
  form.setFieldsValue({
    dateFrom: date,
    dateTo: date?.add(1, 'day').isAfter(today) ? today : date?.add(1, 'day'),
  });
};

export const getAuctionLoanStatus = async (
  originalLoansData: any,
  setPledgeList: any,
) => {
  try {
    const key = originalLoansData[0]?.loanId !== undefined ? 'loanId' : 'id';

    const loanIds = originalLoansData.map((pledge: any) => {
      return pledge?.[key];
    });
    if (loanIds?.length > 0) {
      const response = await postAuctionLoanStatus({ loanIds });

      const auctionMap = new Map(
        response?.data?.auctionLoans?.map((item: any) => [item?.loanId, item]),
      );

      const mergedData = originalLoansData.map((loan: any) => {
        const auction = auctionMap.get(loan?.[key]) as any;

        if (!auction) return loan;

        const { loanStatus, ...auctionRest } = auction;

        return {
          ...loan,
          ...auctionRest,
          auctionLoanStatus: loanStatus,
        };
      });
      setPledgeList(mergedData);
    }
  } catch (e: any) {
    getGenericError();
    if (originalLoansData.length > 0) setPledgeList(originalLoansData);
  }
};

export const capitalizeWords = (text: string) => {
  return text
    .trim()
    .replace(
      /([A-Za-zÀ-ÖØ-öø-ÿ])([A-Za-zÀ-ÖØ-öø-ÿ'’]*)(?=\b)/g,
      (_, first, rest) => first.toUpperCase() + rest.toLowerCase(),
    );
};

export const barcodeLengthCheck = (barcode: any) => {
  const len = barcode?.length ?? 0;
  return len >= 6 && len <= 20;
};
